import {
  Box,
  Container,
  Flex,
  SimpleGrid,
  Spacer,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../../../core/http";
import { trackEvent } from "../../../shared/analytics";
import ReadingOrderHeader from "../../reading/components/ReadingOrderHeader";
import MyReadingOrderForm from "../components/MyReadingOrderForm";

function MyOrdersNew() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [previewReadingOrder, setPreviewReadingOrder] = useState({
    title: "Preview",
    description:
      "Start filling on the form on the right side to see a preview of what your reading order cover will look like.",
  });

  // Handle form submit
  async function handleSubmit(values) {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("franchise", values.franchise);
    formData.append("type", values.type);
    formData.append("order", values.order);
    formData.append("published", 0);
    formData.append("from_year", values.fromYear);
    formData.append("to_year", values.toYear);
    formData.append("is_ongoing", values.isOngoing);
    if (values.thumbnail) {
      formData.append("thumbnail", values.thumbnail);
    }
    setLoading(true);
    try {
      http
        .post("/v1/my-reading-orders", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          setLoading(false);
          trackEvent("my_order_created", {
            reading_order_id: data?.data?.id,
            franchise: values.franchise,
            type: values.type,
          });
          toast({
            title: "Reading order information updated.",
            description: "You can now edit the reading order.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });

          navigate(`/my-orders/${data.data.id}/edit-order`, {
            state: {
              readingOrder: data.data,
            },
          });
        })
        .catch(() => {
          setLoading(false);
        });
      // handle success
    } catch (error) {
      console.error(error);
      setLoading(false);
      // handle error
      toast({
        title: "Error occured",
        description: error.message,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Container maxW="container.lg">
      <SimpleGrid mt="6" columns={{ sm: 1, md: 1, lg: 2 }} spacing={2}>
        <Box>
          <Box bg="gray.700" borderRadius="lg">
            {/* Header */}
            <ReadingOrderHeader
              readingOrder={previewReadingOrder}
              progress={0}
              hideProgress
              showFranchise
            />
            {/* UpNext */}
            <Text p="6">{previewReadingOrder?.description}</Text>
          </Box>
        </Box>

        {/* Reading order header */}
        <Box bg="gray.700" borderRadius="lg">
          <Box
            py="3"
            px="3"
            borderBottomColor="gray.900"
            borderBottomWidth="1px"
          >
            <Flex justifyContent="center">
              <Text fontSize="sm" color="gray.400" mt="2" ml="1">
                CREATE A NEW READING ORDER
              </Text>
              <Spacer />
            </Flex>
          </Box>
          <Box p="6">
            <MyReadingOrderForm
              previewReadingOrder={previewReadingOrder}
              setPreviewReadingOrder={setPreviewReadingOrder}
              handleSubmit={handleSubmit}
              loading={loading}
            />
          </Box>
        </Box>
      </SimpleGrid>
    </Container>
  );
}

export default MyOrdersNew;
